import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FONT_SIZE_SMALL } from '~/Constants/UI.constants';
import { ErrorButton } from '~/UIKit';
import { makeStyles } from '~/UIKit/Style';

const useStyles = makeStyles((theme) => ({
  eventScheduleTimeSeriesDeleteContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row-reverse',
    },
  },
  eventScheduleTimeSeriesDeleteButton: {
    width: 160,
  },
  eventScheduleTimeSeriesDeleteText: {
    fontSize: FONT_SIZE_SMALL,
    lineHeight: '19px',
    padding: '30px 10px',
    textAlign: 'center',
  },
}));

export const EventScheduleTimeSeriesDeleteSectionItem = ({
  onDelete,
}: {
  onDelete: () => void;
}) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  return (
    <div className={classes.eventScheduleTimeSeriesDeleteContainer}>
      <ErrorButton
        size="medium"
        variant="contained"
        onClick={onDelete}
        className={classes.eventScheduleTimeSeriesDeleteButton}
      >
        {t('app.delete')}
      </ErrorButton>
      <Typography className={classes.eventScheduleTimeSeriesDeleteText}>
        {t('event.creation.timeSeries.delete')}
      </Typography>
    </div>
  );
};
